/* ==========================================================================
   Pila Configurator — pila-configurator.js
   Public API: pilaOpenConfigurator() / pilaCloseConfigurator()
   ========================================================================== */

/* ── CONSTANTS ── */
const ROOM_LABELS = {kitchen:'Kitchen',office:'Home Office',living:'Living Room',bedroom:'Bedroom',garage:'Garage'};
const ROOM_ICONS  = {kitchen:'🍳',office:'💻',living:'🛋️',bedroom:'🛏️',garage:'🚗'};
const HD_LABELS   = {ac:'Window A/C',furnace:'Gas Furnace (120V)',sump:'Sump Pump (120V)',aquarium:'Aquarium'};
const HD_ICONS    = {ac:'❄️',furnace:'🔥',sump:'💧',aquarium:'🐠'};
const PRIORITY_LABELS = {
  seamless:   'Automatic backup',
  solar:      'Solar optimization',
  rates:      'Utility optimization',
  fridge:     'Fridge anomaly detection',
  smarthome:  'Smart home integrations',
  simplicity: 'Expandability',
};
const PRIORITY_ICONS = {
  seamless:'⚡', solar:'☀️', rates:'💡', fridge:'🧊', smarthome:'🏠', simplicity:'🔌'
};
const COLORS      = ['white','black','silver','red'];
const COLOR_LABELS= {white:'White',black:'Black',silver:'Silver',red:'Red'};
const COLOR_BG    = {white:'#F0EEEB',black:'#2A2A2A',silver:'#D0D0D0',red:'#D94032'};
const MOUNTS      = [
  {value:'flat',  label:'Flat (default)', note:'No accessory needed'},
  {value:'stand', label:'Vertical Stand',  note:'+Stand Kit'},
  {value:'wall',  label:'Wall Mount',      note:'+Mount Kit'}
];
/* ── PRICE FALLBACKS ── */
const PRICE_BATTERY_FB   = 1299;
const PRICE_EXPANSION_FB = 1199;
const PRICE_STAND_FB     = 89;
const PRICE_WALL_FB      = 99;
const PRICE_FRIDGE_FB    = 79;

/* ── PRODUCT DATA — variant IDs hardcoded, prices refreshed from Shopify variant API ──
   To add accessory variant IDs: Shopify Admin → Products → [product] → variant → check URL
   e.g. /admin/products/10197546959170/variants/[VARIANT_ID_HERE]                        ── */
window.PILA_PRODUCTS = {
  battery: {
    white:  { id: 50606350270786, price: PRICE_BATTERY_FB, image: null },
    black:  { id: 50606350238018, price: PRICE_BATTERY_FB, image: null },
    silver: { id: 50606350303554, price: PRICE_BATTERY_FB, image: null },
    red:    { id: 50606350336322, price: PRICE_BATTERY_FB, image: null },
  },
  expansion: {
    white:  { id: 51766209249602, price: PRICE_EXPANSION_FB },
    black:  { id: 51766209216834, price: PRICE_EXPANSION_FB },
    silver: { id: 51766209282370, price: PRICE_EXPANSION_FB },
    red:    { id: 51766209315138, price: PRICE_EXPANSION_FB },
  },
  fridge: { id: null, price: PRICE_FRIDGE_FB },  /* TODO: replace null with variant ID */
  stand:  { id: null, price: PRICE_STAND_FB },   /* TODO: replace null with variant ID */
  wall:   { id: null, price: PRICE_WALL_FB },    /* TODO: replace null with variant ID */
};

/* Refresh prices + load accessory variant IDs + battery hero images from Shopify */
(function() {
  function fp(h) { return fetch('/products/' + h + '.js').then(function(r) { return r.json(); }); }
  Promise.all([
    fetch('/variants/50606350270786.js').then(function(r) { return r.json(); }), // white  — ref price + image
    fetch('/variants/50606350238018.js').then(function(r) { return r.json(); }), // black  — image
    fetch('/variants/50606350303554.js').then(function(r) { return r.json(); }), // silver — image
    fetch('/variants/50606350336322.js').then(function(r) { return r.json(); }), // red    — image
    fetch('/variants/51766209249602.js').then(function(r) { return r.json(); }), // expansion ref price
    fp('fridge-kit'),
    fp('vertical-stand'),
    fp('wall-mount-bracket'),
  ]).then(function(res) {
    var white = res[0], black = res[1], silver = res[2], red = res[3];
    var bp = white.price / 100, ep = res[4].price / 100;
    var fridge = res[5], stand = res[6], wall = res[7];
    ['white','black','silver','red'].forEach(function(c) {
      window.PILA_PRODUCTS.battery[c].price   = bp;
      window.PILA_PRODUCTS.expansion[c].price = ep;
    });
    // Store variant hero images (featured_image.src from Shopify variant API)
    window.PILA_PRODUCTS.battery.white.image  = white.featured_image  ? white.featured_image.src  : null;
    window.PILA_PRODUCTS.battery.black.image  = black.featured_image  ? black.featured_image.src  : null;
    window.PILA_PRODUCTS.battery.silver.image = silver.featured_image ? silver.featured_image.src : null;
    window.PILA_PRODUCTS.battery.red.image    = red.featured_image    ? red.featured_image.src    : null;
    window.PILA_PRODUCTS.fridge = { id: fridge.variants[0].id, price: fridge.variants[0].price / 100 };
    window.PILA_PRODUCTS.stand  = { id: stand.variants[0].id,  price: stand.variants[0].price  / 100 };
    window.PILA_PRODUCTS.wall   = { id: wall.variants[0].id,   price: wall.variants[0].price   / 100 };
    console.log('Pila: products loaded', window.PILA_PRODUCTS);
  }).catch(function(e) { console.warn('Pila: product fetch error', e); });
}());

/* ── LIVE PRICE HELPERS ── */
function pPrice(color)    { return window.PILA_PRODUCTS?.battery?.[color]?.price   ?? PRICE_BATTERY_FB; }
function pExpPrice(color) { return window.PILA_PRODUCTS?.expansion?.[color]?.price ?? PRICE_EXPANSION_FB; }
function pStandPrice()    { return window.PILA_PRODUCTS?.stand?.price  ?? PRICE_STAND_FB; }
function pWallPrice()     { return window.PILA_PRODUCTS?.wall?.price   ?? PRICE_WALL_FB; }
function pFridgePrice()   { return window.PILA_PRODUCTS?.fridge?.price ?? PRICE_FRIDGE_FB; }

/* ── STATE ── */
const S = { rooms: new Set(), highdraw: new Set(), priorities: new Set(), batteries: [], upsellQty: 1 };

/* ── PUBLIC API — mirrors pila-hero video modal pattern ──
   aria-hidden controls display; .is-open triggers CSS transitions for backdrop + panel ── */
function pilaOpenConfigurator() {
  var wrapper = document.getElementById('pila-configurator');
  if (!wrapper) return;
  wrapper.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      wrapper.classList.add('is-open');
    });
  });
  document.body.style.overflow = 'hidden';
  if (window.Intercom) window.Intercom('update', { hide_default_launcher: true });
}

function pilaCloseConfigurator() {
  var wrapper = document.getElementById('pila-configurator');
  if (!wrapper) return;
  wrapper.classList.remove('is-open');
  setTimeout(function() {
    wrapper.setAttribute('aria-hidden', 'true');
  }, 420);
  document.body.style.overflow = '';
  // if (window.Intercom) window.Intercom('update', { hide_default_launcher: false });
}

// Attach close listeners to backdrop and any [data-configurator-close] elements
document.querySelectorAll('[data-configurator-close]').forEach(function(el) {
  el.addEventListener('click', pilaCloseConfigurator);
});

/* ── NAV ── */
let cur = 'intro';
const FOOTER_SCREENS = new Set(['step1','step2','step3']);
function goTo(id) {
  const a = document.getElementById('screen-' + cur);
  const b = document.getElementById('screen-' + id);
  if (!a || !b) return;
  a.classList.add('exit-left');
  setTimeout(()=>{ a.classList.remove('active','exit-left'); b.classList.add('active'); b.scrollTop = 0; }, 280);
  cur = id;
  document.querySelectorAll('#pila-configurator-panel .footer-set').forEach(f => f.classList.remove('visible'));
  if (FOOTER_SCREENS.has(id)) {
    const fs = document.getElementById('footer-' + id);
    if (fs) fs.classList.add('visible');
  }
}

/* ── STEP 1: ROOMS ── */
function toggleRoom(card) {
  const v = card.dataset.value;
  S.rooms.has(v) ? (S.rooms.delete(v), card.classList.remove('selected')) : (S.rooms.add(v), card.classList.add('selected'));
  document.getElementById('next-step1').disabled = S.rooms.size === 0;
  document.getElementById('edu-rooms').classList.toggle('visible', S.rooms.size > 0);
}

/* ── STEP 2: HIGH-DRAW ── */
function toggleHighdraw(card) {
  const v = card.dataset.value;
  if (S.highdraw.has('none')) {
    S.highdraw.delete('none');
    document.getElementById('highdraw-none').classList.remove('selected');
  }
  S.highdraw.has(v) ? (S.highdraw.delete(v), card.classList.remove('selected')) : (S.highdraw.add(v), card.classList.add('selected'));
  document.getElementById('next-step2').disabled = S.highdraw.size === 0;
}
function toggleHighdrawNone(card) {
  document.querySelectorAll('#highdraw-options .option-card:not(#highdraw-none)').forEach(c => c.classList.remove('selected'));
  S.highdraw.clear();
  if (card.classList.contains('selected')) {
    card.classList.remove('selected');
  } else {
    card.classList.add('selected');
    S.highdraw.add('none');
  }
  document.getElementById('next-step2').disabled = S.highdraw.size === 0;
}

/* ── STEP 3: PRIORITIES — multi-select ── */
function togglePriority(card) {
  if (!card || !card.dataset) return;
  // Guard: ensure priorities is always a Set (defensive against stale cached JS)
  if (!S.priorities || !(S.priorities instanceof Set)) S.priorities = new Set();
  const v = card.dataset.value;
  if (!v) return;
  if (S.priorities.has(v)) {
    S.priorities.delete(v);
    card.classList.remove('selected');
  } else {
    S.priorities.add(v);
    card.classList.add('selected');
  }
  const btn = document.getElementById('next-step3');
  if (btn) btn.disabled = S.priorities.size === 0;
}

/* ── LOADING ── */
function showLoading() {
  goTo('loading');

  // Restart fill animation via class toggle (avoids !important inline style conflict)
  const ring = document.getElementById('pila-loading-ring');
  if (ring) {
    ring.classList.remove('is-animating');
    void ring.getBoundingClientRect(); // force reflow
    ring.classList.add('is-animating');
  }

  const rooms    = [...S.rooms].map(r  => ({icon: ROOM_ICONS[r],    label: ROOM_LABELS[r]}));
  const hd       = [...S.highdraw].filter(v => v !== 'none').map(h => ({icon: HD_ICONS[h],     label: HD_LABELS[h]}));
  const allItems = [...rooms, ...hd];

  // Build rows: one per space/appliance, then one per selected priority
  const rows = allItems.map(it => ({icon: it.icon, label: it.label, considering: false}));
  S.priorities.forEach(p => {
    rows.push({icon: PRIORITY_ICONS[p] || '✦', label: `Considering ${PRIORITY_LABELS[p] || p}…`, considering: true});
  });

  const container = document.getElementById('loading-rows');
  container.innerHTML = '';
  const els = rows.map(r => {
    const el = document.createElement('div');
    el.className = 'loading-row' + (r.considering ? ' considering' : '');
    el.innerHTML = `<span class="loading-row-icon">${r.icon}</span>${r.label}`;
    container.appendChild(el);
    return el;
  });

  // Stagger space rows across first ~3s; priority rows appear at 3.6s+
  const spaceRows      = rows.filter(r => !r.considering);
  const priorityRows   = rows.filter(r => r.considering);
  const stagger        = spaceRows.length > 1 ? Math.min(440, 2400 / Math.max(spaceRows.length - 1, 1)) : 0;

  els.forEach((el, i) => {
    const r = rows[i];
    let delay;
    if (!r.considering) {
      const spaceIdx = spaceRows.indexOf(r);
      delay = 260 + spaceIdx * stagger;
    } else {
      const priIdx = priorityRows.indexOf(r);
      delay = 3600 + priIdx * 300;
    }
    setTimeout(() => el.classList.add('visible'), delay);
  });

  setTimeout(() => { buildResults(); goTo('results'); }, 5300);
}

/* ── RESULTS ENGINE ── */
function buildResults() {
  const rooms    = [...S.rooms];
  const highdraw = [...S.highdraw].filter(v => v !== 'none');
  const batteryCount = Math.max(1, Math.min(rooms.length + highdraw.length, 6));

  S.upsellQty = 1;

  const zones = [
    ...rooms.map(r   => ({key: r, label: ROOM_LABELS[r],  icon: ROOM_ICONS[r]})),
    ...highdraw.map(h => ({key: h, label: HD_LABELS[h],   icon: HD_ICONS[h]}))
  ].slice(0, batteryCount);
  if (zones.length === 0) zones.push({key:'home', label:'Home', icon:'🏠'});

  S.batteries = zones.map((z, i) => ({
    ...z,
    idx: i,
    color: i % 2 === 0 ? 'white' : 'black',   // ← was: 'white'
    mount: (z.key === 'bedroom' || z.key === 'office') ? 'stand'
        : (z.key === 'sump'    || z.key === 'furnace') ? 'wall'
        : 'flat'
  }));

  const allZones = zones.map(z => z.label).join(', ');
  const configName = batteryCount===1?'Starter Setup':batteryCount===2?'Essentials Setup':batteryCount<=4?'Whole-Home Setup':'Extended Resilience Setup';
  document.getElementById('primary-name').textContent = `${batteryCount}-Battery ${configName}`;
  document.getElementById('primary-desc').textContent = `${batteryCount} Pila ${batteryCount===1?'Battery':'Batteries'} covering ${allZones}.`;

  recalcPrice();
  updateAccessoryChips();
  renderBatteryVisual();
  renderBatteryRows();

  // Backup chart
  const bd = buildBackupData(rooms, highdraw);
  const mx = Math.max(...bd.map(b => b.hrs));
  document.getElementById('backup-times-list').innerHTML = bd.map(b => `
    <div class="backup-row">
      <div class="backup-appliance">${b.icon} ${b.label}</div>
      <div class="backup-bar-wrap"><div class="backup-bar" data-pct="${Math.round(b.hrs/mx*100)}"></div></div>
      <div class="backup-time">${b.hrs} hrs</div>
    </div>`).join('');

  // Double rAF ensures DOM is painted before triggering scaleX transition
  requestAnimationFrame(() => requestAnimationFrame(() => {
    document.querySelectorAll('#pila-configurator-panel .backup-bar').forEach(b => {
      b.style.transform = 'scaleX(' + (b.dataset.pct / 100) + ')';
    });
  }));

  // Upsell headline
  const hasExpand = S.priorities.has('seamless');
  document.getElementById('upsell-headline').innerHTML = hasExpand
    ? '<em>Double your backup time.</em> Add an Expansion Battery.'
    : 'More coverage, more peace of mind.';
  document.getElementById('upsell-price').textContent = `$${pExpPrice(S.batteries[0]?.color || 'white').toLocaleString()} per battery`;
  S.upsellQty = 1;
  updateUpsellQtyUI();
}

/* ── PRICE CALC ── */
function recalcPrice() {
  const n = S.batteries.length;
  const hasFridgeSpace = S.batteries.some(b => b.key==='kitchen' || b.key==='garage') || S.priorities.has('fridge');
  const wallCount  = S.batteries.filter(b => b.mount==='wall').length;
  const standCount = S.batteries.filter(b => b.mount==='stand').length;
  const total = S.batteries.reduce((sum, b) => sum + pPrice(b.color), 0)
    + (hasFridgeSpace ? pFridgePrice() : 0)
    + wallCount * pWallPrice()
    + standCount * pStandPrice();
  const parts = [`${n} ${n===1?'battery':'batteries'}`];
  if (wallCount > 0)  parts.push(`Wall Mount Kit${wallCount > 1 ? ' ×'+wallCount : ''}`);
  if (standCount > 0) parts.push(`Vertical Stand${standCount > 1 ? ' ×'+standCount : ''}`);
  if (hasFridgeSpace) parts.push('Fridge Sensor Kit');
  document.getElementById('primary-price').innerHTML =
    `$${total.toLocaleString()} <span>estimated</span>` +
    `<div class="price-detail">${parts.join(' · ')}</div>`;
  const configName = n===1?'Starter Setup':n===2?'Essentials Setup':n<=4?'Whole-Home Setup':'Extended Resilience Setup';
  document.getElementById('primary-name').textContent = `${n}-Battery ${configName}`;
  document.getElementById('primary-desc').textContent = `${n} Pila ${n===1?'Battery':'Batteries'} covering ${S.batteries.map(b=>b.label).join(', ')}.`;
}

function updateAccessoryChips() { /* chips removed — info now lives in price detail line */ }

/* ── BATTERY VISUAL — flat overlapping deck ── */
function renderBatteryVisual() {
  const v = document.getElementById('primary-visual');
  v.innerHTML = '';
  const shown = S.batteries.slice(0, 5);
  const n = shown.length;

  const CARD_W = 130;
  // ≤3 batteries: spread with positive gap; >3: overlap to fit
  const OVERLAP = n <= 1 ? 0 : n <= 3 ? -14 : Math.min(40, Math.max(20, Math.round((n * CARD_W - 320) / (n - 1))));

  const deck = document.createElement('div');
  deck.style.cssText = 'display:flex;align-items:flex-start;flex-shrink:0;';

  shown.forEach((b, i) => {
    const card = document.createElement('div');
    card.className = `result-battery-card color-${b.color}`;
    card.id = `vis-batt-${b.idx}`;
    card.style.cssText = [
      `width:${CARD_W}px`,
      `flex-shrink:0`,
      `position:relative`,
      `z-index:${i + 1}`,
      i > 0 ? `margin-left:-${OVERLAP}px` : '',
    ].filter(Boolean).join(';') + ';';

    const imgSrc = window.PILA_BATTERY_IMAGES?.[b.color] || window.PILA_PRODUCTS?.battery?.[b.color]?.image;
    if (imgSrc) {
      const imgEl = document.createElement('img');
      imgEl.src = imgSrc;
      imgEl.alt = '';
      imgEl.style.cssText = 'width:100%;height:auto;display:block;';
      card.appendChild(imgEl);
    } else {
      const fallback = document.createElement('div');
      fallback.style.cssText = `width:${CARD_W}px;height:${Math.round(CARD_W*1.2)}px;background:${COLOR_BG[b.color]};border-radius:8px;`;
      card.appendChild(fallback);
    }
    deck.appendChild(card);
  });

  v.appendChild(deck);

  if (S.batteries.length > 5) {
    const m = document.createElement('div');
    m.style.cssText = 'font-family:var(--font-mono);font-size:10px;color:#999999;margin-top:10px;text-align:center;width:100%;';
    m.textContent = `+${S.batteries.length - 5} more`;
    v.appendChild(m);
  }
}

/* ── PER-BATTERY ROWS ── */
function renderBatteryRows() {
  const canDelete = S.batteries.length > 1;
  document.getElementById('battery-rows').innerHTML = S.batteries.map((b, i) => `
    <div class="battery-row" id="brow-${i}">
      <div class="battery-row-header">
        <div class="battery-row-icon" id="brow-icon-${i}" style="background:${COLOR_BG[b.color]}">${b.icon}</div>
        <div style="flex:1;min-width:0;">
          <div class="battery-row-name">Battery ${i+1} — ${b.label}</div>
          <div class="battery-row-sub" id="brow-sub-${i}">${mountLabel(b.mount)} · ${COLOR_LABELS[b.color]}</div>
        </div>
        ${canDelete ? `<button class="brow-delete" onclick="confirmRemoveBattery(${i})" title="Remove battery ${i+1}" aria-label="Remove battery ${i+1}">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M1 1l10 10M11 1L1 11"/></svg>
        </button>` : ''}
      </div>
      <div class="config-label">Color</div>
      <div class="color-swatches" style="align-items:center;">
        ${COLORS.map(c => `<div class="color-swatch swatch-${c}${b.color===c?' selected':''}" title="${COLOR_LABELS[c]}" onclick="setBatteryColor(${i},'${c}')"></div>`).join('')}
        <span class="color-swatch-label" id="brow-colorlabel-${i}">${COLOR_LABELS[b.color]}</span>
      </div>
      <div class="config-label">Mounting</div>
      <div class="mount-options" id="brow-mounts-${i}">
        ${MOUNTS.map(m => `<div class="mount-option${b.mount===m.value?' selected':''}" data-mount="${m.value}" onclick="setBatteryMount(${i},'${m.value}')"><div class="mount-option-dot"></div>${m.label}</div>`).join('')}
      </div>
    </div>`).join('');
  updateConfigSummaryLine();
}

function mountLabel(m) { return {flat:'Flat', stand:'Vertical Stand', wall:'Wall Mount'}[m]; }
function mountNote(m)  { return {flat:'No accessory needed', stand:`Includes Vertical Stand Kit ($${pStandPrice()})`, wall:`Includes Wall Mounting Kit ($${pWallPrice()})`}[m]; }

/* ── SET COLOR ── */
function setBatteryColor(idx, color) {
  S.batteries[idx].color = color;
  document.querySelectorAll(`#brow-${idx} .color-swatch`).forEach(s => {
    s.classList.toggle('selected', COLORS.some(c => c===color && s.classList.contains('swatch-'+c)));
  });
  document.getElementById(`brow-icon-${idx}`).style.background = COLOR_BG[color];
  const vis = document.getElementById(`vis-batt-${idx}`);
  if (vis) {
    COLORS.forEach(c => vis.classList.remove('color-' + c));
    vis.classList.add('color-' + color);
    // vis.style.background = COLOR_BG[color];  ← remove this line
    const img = vis.querySelector('img');
    const newSrc = window.PILA_BATTERY_IMAGES?.[color] || window.PILA_PRODUCTS?.battery?.[color]?.image;
    if (img && newSrc) img.src = newSrc;
  }
  document.getElementById(`brow-sub-${idx}`).textContent = `${mountLabel(S.batteries[idx].mount)} · ${COLOR_LABELS[color]}`;
  document.getElementById(`brow-colorlabel-${idx}`).textContent = COLOR_LABELS[color];
  updateConfigSummaryLine();
}

/* ── SET MOUNT ── */
function setBatteryMount(idx, mount) {
  S.batteries[idx].mount = mount;
  document.querySelectorAll(`#brow-mounts-${idx} .mount-option`).forEach(opt => {
    opt.classList.toggle('selected', opt.dataset.mount === mount);
  });
  document.getElementById(`brow-sub-${idx}`).textContent = `${mountLabel(mount)} · ${COLOR_LABELS[S.batteries[idx].color]}`;
  updateConfigSummaryLine();
  updateAccessoryChips();
  recalcPrice();
}

function updateConfigSummaryLine() { /* static label */ }

/* ── DELETE BATTERY ── */
let pendingDeleteIdx = null;
function confirmRemoveBattery(idx) {
  pendingDeleteIdx = idx;
  const b = S.batteries[idx];
  document.getElementById('confirm-modal-title').textContent = `Remove ${b.label} battery?`;
  document.getElementById('confirm-remove-btn').onclick = executeBatteryRemove;
  document.getElementById('confirm-modal-overlay').classList.add('open');
}
function executeBatteryRemove() {
  if (pendingDeleteIdx === null) return;
  S.batteries.splice(pendingDeleteIdx, 1);
  S.batteries.forEach((b, i) => b.idx = i);
  S.upsellQty = Math.min(S.upsellQty, S.batteries.length);
  closeConfirmModal();
  renderBatteryVisual();
  renderBatteryRows();
  updateAccessoryChips();
  recalcPrice();
  updateUpsellQtyUI();
}
function closeConfirmModal(e) {
  if (e && e.target !== document.getElementById('confirm-modal-overlay')) return;
  document.getElementById('confirm-modal-overlay').classList.remove('open');
  pendingDeleteIdx = null;
}

/* ── ACCORDION ── */
let configOpen = false;
function toggleConfig() {
  configOpen = !configOpen;
  document.getElementById('config-body').classList.toggle('open', configOpen);
  document.getElementById('config-chevron').classList.toggle('open', configOpen);
}

/* ── BACKUP DATA ── */
function buildBackupData(rooms, highdraw) {
  const d = [];
  if (rooms.includes('kitchen')||rooms.includes('garage')) d.push({icon:'🧊', label:'Refrigerator', hrs:32});
  if (rooms.includes('office')||rooms.includes('living'))  d.push({icon:'📡', label:'WiFi / Router', hrs:132});
  if (rooms.includes('bedroom')||rooms.includes('living')) d.push({icon:'💡', label:'LED Lights', hrs:158});
  if (rooms.includes('living'))  d.push({icon:'📺', label:'TV', hrs:32});
  if (rooms.includes('office'))  d.push({icon:'💻', label:'Laptop', hrs:23});
  if (rooms.includes('bedroom')) d.push({icon:'🌬️', label:'Air Purifier', hrs:40});
  if (rooms.includes('garage'))  d.push({icon:'🚪', label:'Garage Door', hrs:48});
  if (highdraw.includes('ac'))       d.push({icon:'❄️', label:'Window A/C', hrs:6});
  if (highdraw.includes('furnace'))  d.push({icon:'🔥', label:'Gas Furnace', hrs:24});
  if (highdraw.includes('sump'))     d.push({icon:'💧', label:'Sump Pump', hrs:12});
  if (highdraw.includes('aquarium')) d.push({icon:'🐠', label:'Aquarium', hrs:79});
  if (d.length === 0) d.push({icon:'🔌', label:'Typical appliances', hrs:32});
  return d.slice(0, 5);
}

/* ── UPSELL QTY ── */
function changeUpsellQty(delta) {
  S.upsellQty = Math.max(1, Math.min(S.batteries.length, S.upsellQty + delta));
  updateUpsellQtyUI();
}
function updateUpsellQtyUI() {
  const n   = S.batteries.length;
  const el  = document.getElementById('upsell-qty-display');
  const dec = document.getElementById('upsell-qty-dec');
  const inc = document.getElementById('upsell-qty-inc');
  if (el)  el.textContent      = S.upsellQty;
  if (dec) dec.style.opacity   = S.upsellQty <= 1 ? '0.3' : '1';
  if (inc) inc.style.opacity   = S.upsellQty >= n ? '0.3' : '1';
}
function addUpsellToCart() {
  const btn = document.querySelector('#pila-configurator-panel .btn-cart-upsell');
  const orig = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  const items = [];
  for (let i = 0; i < S.upsellQty; i++) {
    const color = S.batteries[i]?.color || S.batteries[0]?.color || 'white';
    const id = window.PILA_PRODUCTS?.expansion?.[color]?.id;
    if (id) items.push({ id, quantity: 1,
      properties: { 'Expansion for': S.batteries[i]?.label || 'Battery ' + (i+1) }
    });
  }
  if (!items.length) { if (btn) { btn.disabled = false; btn.innerHTML = orig; } return; }
  postToCart(items, btn, orig);
}

/* ── ADD TO CART ── */
function addToCart() {
  const btn = document.querySelector('#pila-configurator-panel .btn-cart-main');
  const orig = btn ? btn.innerHTML : '';
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

  const items = [];
  S.batteries.forEach(b => {
    const id = window.PILA_PRODUCTS?.battery?.[b.color]?.id;
    if (id) items.push({ id, quantity: 1 });
    if (b.mount === 'wall') {
      const wid = window.PILA_PRODUCTS?.wall?.id;
      if (wid) items.push({ id: wid, quantity: 1 });
    }
    if (b.mount === 'stand') {
      const sid = window.PILA_PRODUCTS?.stand?.id;
      if (sid) items.push({ id: sid, quantity: 1 });
    }
  });
  const hasFridge = S.batteries.some(b => b.key==='kitchen'||b.key==='garage') || S.priorities.has('fridge');
  if (hasFridge) {
    const fid = window.PILA_PRODUCTS?.fridge?.id;
    if (fid) items.push({ id: fid, quantity: 1 });
  }
  if (!items.length) { if (btn) { btn.disabled = false; btn.innerHTML = orig; } return; }
  postToCart(items, btn, orig);
}

/* ── SHARED CART POST ── */
function postToCart(items, btn, origHTML) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) {
      console.error('Cart error:', data.description);
      if (btn) { btn.disabled = false; btn.innerHTML = origHTML; }
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    pilaCloseConfigurator();
    setTimeout(function() {
      window.location = '/cart';
    }, 450);
  })
  .catch(function() {
    if (btn) { btn.disabled = false; btn.innerHTML = origHTML; }
  });
}

/* ── RETAKE ── */
function retakeQuiz() {
  S.rooms.clear();
  S.highdraw.clear();
  S.priorities.clear();
  S.batteries = [];
  S.upsellQty = 1;
  document.querySelectorAll('#pila-configurator-panel .option-card').forEach(c => c.classList.remove('selected'));
  document.querySelectorAll('#pila-configurator-panel [id^="next-step"]').forEach(b => b.disabled = true);
  document.getElementById('edu-rooms').classList.remove('visible');
  configOpen = false;
  // Remove animation class so it can restart next time
  const ring = document.getElementById('pila-loading-ring');
  if (ring) ring.classList.remove('is-animating');
  goTo('intro');
}